/**
 * panelDavetiService.js — bir kişiye SMS ile "geçici kişi paneli" daveti (backlog #647; backend #644 / #633).
 *
 * ⚠ SÖZLEŞME VARSAYIMDIR: #644 henüz yazılmadı. Yollar #644'ün metninden (`POST /personnel/{personId}/panel-daveti`) ve durum listesinden çıkarıldı;
 * backend yazılırken ya buna uyulur ya da bu dosya ve testi birlikte güncellenir.
 *
 *   GET    /personnel/{personId}/panel-daveti → { enabled, status, phone_masked, phone_problem, sent_at, expires_at, last_used_at, resend_after_seconds }
 *   POST   /personnel/{personId}/panel-daveti → daveti kurar ve SMS'i yollar (eskisini iptal eder); 201 aynı biçim · 429 yeniden gönderme beklemesi (data.retry_after_seconds)
 *                                               · 400 numara kullanılamaz (phone_problem) · 409/403 yetki ya da kişi uygun değil
 *   DELETE /personnel/{personId}/panel-daveti → daveti iptal eder (status REVOKED); aynı biçim
 * `status`: NONE (hiç davet yok) · SENT (gönderildi) · OPENED (bağlantı açıldı) · ACTIVE (giriş yapıldı) · EXPIRED (süresi doldu) · LOCKED (5 yanlış deneme) · REVOKED (iptal)
 * `phone_problem`: null (numara kullanılabilir) · EMPTY · INVALID · LANDLINE · INTERNATIONAL — #633'ün numara sınıfları; yalnızca geçerli bir Türkiye cep numarasına SMS gider.
 * `enabled`: false iken geçici panel anahtarı (sms.gecici_panel.etkin) kapalıdır — davet gitmez.
 * Numarayı düzeltmek için mevcut künye PATCH'i kullanılır (kisiKunyeService.patchKunye); telefon maskeli gelir, tam numara bu ekrana hiç inmez.
 */
import axios from 'axios';
import { JAVA_BACKEND_API_URL, getAuthHeader } from '../Components/Contexts/BackendConstants';
import { smsHatasi } from './smsAyarService';

const BASE = `${JAVA_BACKEND_API_URL}/personnel`;

async function al(istek) {
  try {
    return (await istek()).data;
  } catch (error) {
    throw smsHatasi(error);
  }
}

export const DAVET_DURUMLARI = ['NONE', 'SENT', 'OPENED', 'ACTIVE', 'EXPIRED', 'LOCKED', 'REVOKED'];
export const NUMARA_SORUNLARI = ['EMPTY', 'INVALID', 'LANDLINE', 'INTERNATIONAL'];

export const getPanelDaveti = (personId) => al(() => axios.get(`${BASE}/${personId}/panel-daveti`, { headers: getAuthHeader() }));
export const sendPanelDaveti = (personId) => al(() => axios.post(`${BASE}/${personId}/panel-daveti`, {}, { headers: getAuthHeader() }));
export const revokePanelDaveti = (personId) => al(() => axios.delete(`${BASE}/${personId}/panel-daveti`, { headers: getAuthHeader() }));

/** Davet gönderilebilir mi (numara kullanılabilir, anahtar açık, bir davet yok ya da bitti)? Yeniden gönderme ayrıdır: `yenidenGonderilebilir`. */
export const ilkDavetGonderilebilir = (d) => !!d && d.enabled !== false && !d.phone_problem && ['NONE', 'EXPIRED', 'REVOKED', 'LOCKED'].includes(d.status);
export const yenidenGonderilebilir = (d) => !!d && d.enabled !== false && !d.phone_problem && ['SENT', 'OPENED', 'ACTIVE'].includes(d.status);
export const iptalEdilebilir = (d) => !!d && ['SENT', 'OPENED', 'ACTIVE', 'LOCKED'].includes(d.status);
